import { Passengers } from './passenger.model';
import { AddonEntity } from './booking.model';
import { StopItem } from '../services/reference-data.service';

export class Message {
    constructor(public level: string, public detail: string) { }

    public isError() {
        return this.detail === 'Error';
    }
}
export enum TimeRadioButton {
    ANY_TIME = 'Any time',
    AM = 'AM',
    PM = 'PM'
}
export class TimeTableTravelOptions {
    fromStop: any;
    from: string; // Code
    toStop: any;
    to: string; // Code
    isArriving?: boolean;
    departAfter?: string;
    arriveBy?: string;
    time?: TimeRadioButton;

    passengers: Passengers;
    promoCode: string;
}
export class TravelOptions {
    options: AvailabilityOption;
    to: StopItem;
    from: StopItem;
    passengers: Passengers;
    get returnDate() {
        return this.options.isReturn ? this.options.TravelLegs[1].travelDate : null;
    }
    get departureDate() {
        return this.options.TravelLegs[0].travelDate;
    }
    get isReturn() {
        return this.options.isReturn;
    }
    get promoCode() {
        return this.options.TravelLegs[0].promotionCode;
    }
}
export class TravelLeg {
    constructor(
        public origin?: any,
        public destination?: any,
        public travelDate?: string,
        public promotionCode?: string,
    ) { }
}
export class AvailabilityOption {
    // there is no seatedInfants
    constructor(public agentCode?: string,
        public fareBasis1Code?: string,
        public fareBasis1Count?: number,
        public fareBasis2Code?: string,
        public fareBasis2Count?: number,
        public fareBasis3Code?: string,
        public fareBasis3Count?: number,
        public isReturn?: boolean,
        public nursedInfants?: number,
        public specialAssistance?: boolean,
        public sATypeId?: number,
        public TravelLegs?: Array<TravelLeg>,
        public currentSlide?: number,
        public getAlternates?: boolean,
        public getNextAvailable?: boolean) {
        this.sATypeId = !!sATypeId ? sATypeId : 0;
        this.TravelLegs = !!TravelLegs ? TravelLegs : [];
        this.currentSlide = !!currentSlide ? currentSlide : 0;
        this.getAlternates = !!getAlternates ? getAlternates : true;
        this.getNextAvailable = !!getNextAvailable ? getNextAvailable : false;
    }
}

export class GetTimetableOption {
    constructor(public origin: string,
        public destination: string,
        public departAfter: string,
        public arriveBy: string) {
    }
}
export class PostTimetableOption {
    constructor(private serviceNumber: number, private originStopCode: string, private destinationStopCode: string) { }
}
export class TimetableResponse {
    type: string;
    entities: Array<AddonEntity>;
}

export class PickadateContext {
    select: number;
    clear: any;
}

export class RouteOption {
    DepartureDate: string;
    ArrivalDate: string;
    Connections: number;
    RouteHeader: string;
    RouteServices: Array<RouteService>;
    Fares: Array<any>;
}
export class RouteService {
    Stops: Array<Stop>;
}
export class Stop {
    StopDetails: Array<StopDetailsContainer>;
    date: string;
    ArrivalDate: string;
    DepartureDate: string;
}
export class StopDetailsContainer {
    Address: string;
    Addresses: StopAddress[];
    AddressNumber: number;
    AvailableOnline: boolean;
    Code: string;
    ContractStop: boolean;
    Description: string;
    DestinationCode: string;
    DestinationName: string;
    ID: number;
    IsPopular: boolean;
    IsTerminal: boolean;
    Latitude: number;
    Longitude: number;
    Offset: number;
    OriginDisplayName: string;
    Radius: number;
    SortOrder: number;
    State: string;
    StateCode: string;
    StateId: number;
    StateName: string;
    StopOver: boolean;
    StreetAddress: string;
    TerminalDetails: string;
    TownName: string;
    TownUFI: string;
    Type: string;
    StopDetails: string;
}

export class StopAddress {
    Address: string;
    AddressNumber: number;
    Latitude: number;
    Longitude: number;
    Memo: string;
    Radius: number;
}
export class Link {
    public Url: string;
    public Name: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/timetables.model.ts